import React, { useState, useEffect } from 'react'
import { Container, Typography, Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton, TextField } from '@material-ui/core';
import { Search, Clear } from "@material-ui/icons"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { workAPI } from '../services/WorkService'
import { Search_Panel } from './../components/Work_SearchPanel/index'
import Swal from "sweetalert2";
import moment from 'moment';
import Download from "downloadjs"
import { NoIpadDevice } from "../utils/config";

const Report = () => {
    const [data, setData] = useState([])
    const [force, setForce] = useState(0)
    const [type, setType] = useState([]);
    const [SelectType, setSelectType] = useState(null);
    const [startDate, setStartDate] = useState(moment().startOf('month').toDate());
    const [endDate, setEndDate] = useState(moment(startDate).endOf('month').toDate());
    const [searchText, setSearchText] = useState("")
    const [sortBy, setSortBy] = useState("status")
    const [sortOrder, setSortOrder] = useState("asc")
    const [page, setPage] = useState(0);
    const [rowsPerPage, setrowsPerPage] = useState(10);

    useEffect(() => {
        document.title = 'Com7 Merchandise - Report'
        workAPI.reportByType({ date_start: startDate, date_end: endDate })
            .then((res) => {
                if (res.status == 200) {
                    if (Array.isArray(res.message)) {
                        setData(res.message)
                        let type_fromdata = res.message.reduce((prev, curr) => {
                            let find_dup_type = prev.find((res) => res.value == curr.type)
                            if (!find_dup_type) {
                                prev.push({ value: curr.type, label: curr.type })
                            }
                            return prev
                        }, [])
                        setType(type_fromdata)
                        setSelectType(null)
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            confirmButtonColor: "#f27474",
                            html: `<span class="colorWhite">API DATA is not Array</span>`,
                            backdrop: 'transparent',
                            background: 'rgba(0,0,0,.75)',
                            customClass: {
                                icon: 'switch'
                            },
                            width: '28rem',
                            timer: 5000
                        }).then(() => {
                            setForce((old) => old + 1)
                        })
                    }
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">Something Wrong!!!</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 5000
                    }).then(() => {
                        setForce((old) => old + 1)
                    })
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${error.message}</span>`,
                    backdrop: 'transparent',
                    background: 'rgba(0,0,0,.75)',
                    customClass: {
                        icon: 'switch'
                    },
                    width: '28rem',
                    timer: 5000
                }).then(() => {
                    setForce((old) => old + 1)
                })
            })

    }, [force, startDate, endDate])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setrowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const secondsToDhms = (minutes) => {
        let seconds = Number(minutes) * 60;
        let d = Math.floor(seconds / (3600 * 24));
        let h = Math.floor(seconds % (3600 * 24) / 3600);
        let m = Math.floor(seconds % 3600 / 60);
        let s = Math.floor(seconds % 60);
        let dDisplay = d > 0 ? d + " วัน " : "";
        let hDisplay = h > 0 ? h + " ชั่วโมง " : "";
        let mDisplay = m > 0 ? m + " นาที " : "";
        let sDisplay = s > 0 ? s + " วินาที" : "";
        return dDisplay + hDisplay + mDisplay + sDisplay;
    }

    const caseWork = (params) => {
        switch (params) {
            case "New": return Number(1);
            case "Pending": return Number(2);
            case "Accept": return Number(3);
            case "Decline": return Number(4);
            default: return params;
        }
    }

    const sortData = () => {
        let compareFn = null;
        switch (sortBy) {
            case "total_work":
                compareFn = (i, j) => {
                    if (Number(caseWork(i[sortBy])) < Number(caseWork(j[sortBy]))) {
                        return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
                    } else {
                        if (Number(caseWork(i[sortBy])) > Number(caseWork(j[sortBy]))) {
                            return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0
                        } else {
                            return 0;
                        }
                    }
                };
                break;
            case "total_time":
                compareFn = (i, j) => {
                    if (Number(caseWork(i[sortBy])) < Number(caseWork(j[sortBy]))) {
                        return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
                    } else {
                        if (Number(caseWork(i[sortBy])) > Number(caseWork(j[sortBy]))) {
                            return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0
                        } else {
                            return 0;
                        }
                    }
                };
                break;
            default: compareFn = (i, j) => {
                if (i[sortBy] < j[sortBy]) {
                    return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
                } else {
                    if (i[sortBy] > j[sortBy]) {
                        return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0
                    } else {
                        return 0;
                    }
                }
            }
        }
        return compareFn;
    }
    let searchProps = { startDate, setStartDate, endDate, setEndDate, type, SelectType, setSelectType }

    const requestSearch = (searchValue) => {
        setSearchText(searchValue);
    };

    const changeSortable = (name) => {
        if (name == sortBy) {
            if (sortOrder == "asc") {
                setSortOrder("desc")
            }
            else if (sortOrder == "desc") {
                setSortOrder("")
                setSortBy("")
            }
            else {
                setSortOrder("asc")
            }
        }
        else {
            setSortOrder("asc")
        }
    }

    const filterCondition = (res) => {
        let concat_string = res.type.concat(res.total_work, res.total_time, res.createdAt, res.fullname2, res.id_created, res.updatedAt)
        if (searchText != "" && SelectType) return concat_string.toLowerCase().includes(searchText.toLowerCase()) && res.type == SelectType
        if (searchText != "" && !SelectType) return concat_string.toLowerCase().includes(searchText.toLowerCase())
        if (searchText == "" && SelectType) return res.type == SelectType
        else return true
    }

    const Export_Excel = () => {
        Swal.fire({
            title: 'คุณแน่ใจ ?',
            text: "ต้องการ Export ข้อมูลใช่หรือไม่ ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#56A834',
            cancelButtonColor: 'red',
            denyButtonColor: '#d33',
            confirmButtonText: 'ใช่',
            cancelButtonText: 'ยกเลิก',
        }).then((result) => {

            if (result.isConfirmed) {
                workAPI.ExportExcelbyType({ date_start: startDate, date_end: endDate })
                    .then((response) => {
                        if (response.status == 200) {
                            Download(response.data, `Report_Merchandise_By_Type - ${moment().format("DD-MM-YYYY HH-mm-ss")}.xlsx`, response.headers['content-type'])
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                confirmButtonColor: "#f27474",
                                html: `<span class="colorWhite">${response.message}</span>`,
                                timer: 3000
                            })
                        }
                    })
            }
        })
    }

    return (
        <React.Fragment>
            {NoIpadDevice ? <Container style={{ paddingLeft: '0', paddingRight: '0' }}>
                <Typography component="div" style={{ backgroundColor: '#ffffffe6', borderRadius: '15px', height: '93vh' }}>
                    <Container style={{ marginTop: '10px', height: '5%', }}>
                        <span style={{ fontSize: "1.5em", fontWeight: 'bold', cursor: 'pointer' }} >
                            Report
                        </span>
                    </Container>
                    <Container style={{ padding: '25px', borderBottom: '2px solid lightgray' }}>

                        <Box style={{ margin: 'auto 0' }} color="primary.main">
                            <Search_Panel data={data} {...searchProps} />
                        </Box>
                    </Container>
                    <div style={{ padding: '10px' }}>
                        <div className="flex-container ">
                            <div style={{ marginRight: 'auto' }}>

                                <TextField
                                    style={{ marginRight: 'auto', justifyContent: 'flex-end' }}
                                    variant="standard"
                                    value={searchText}
                                    onChange={(event) => requestSearch(event.target.value)}
                                    placeholder="Search…"
                                    InputProps={{
                                        startAdornment: <Search fontSize="small" />,
                                        endAdornment: (
                                            <IconButton
                                                title="Clear"
                                                aria-label="Clear"
                                                size="small"
                                                style={{ visibility: searchText != '' ? 'visible' : 'hidden' }}
                                                onClick={() => requestSearch('')}
                                            >
                                                <Clear fontSize="small" />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </div>
                            <div style={{ marginLeft: 'auto' }}>
                                <Button
                                    variant='contained'
                                    style={{ backgroundColor: "#6ab23a", color: 'whitesmoke', whiteSpace: 'nowrap', textTransform: 'none' }}
                                    size="small"
                                    onClick={Export_Excel}
                                >
                                    Export<FontAwesomeIcon style={{ marginLeft: '5px' }} icon={faFileExcel} size="lg" />
                                </Button>
                            </div>
                        </div>

                        <TableContainer component={Paper} style={{ borderRadius: '10px', marginTop: '2%', display: data.length == 0 ? 'none' : 'block' }}>
                            <Table className="ayLmao">
                                <TableHead className="heheXd"
                                    style={{
                                        height: '50px',
                                        position: "sticky",
                                        textAlign: 'center'
                                    }}>
                                    <TableRow >
                                        <TableCell onClick={() => { setSortBy("type"); changeSortable("type") }}>Type Name</TableCell>
                                        <TableCell onClick={() => { setSortBy("total_work"); changeSortable("total_work") }}>จำนวนงานทั้งหมด</TableCell>
                                        <TableCell onClick={() => { setSortBy("count_declice"); changeSortable("count_declice") }}>จำนวนงานที่ปิดแล้วทั้งหมด</TableCell>
                                        <TableCell onClick={() => { setSortBy("count_declice"); changeSortable("count_declice") }}>จำนวนงานที่ปฏิเสธทั้งหมด</TableCell>
                                        <TableCell onClick={() => { setSortBy("total_new"); changeSortable("total_new") }}>ระยะเวลาในการรับเรื่องทั้งหมด</TableCell>
                                        <TableCell onClick={() => { setSortBy("total_update"); changeSortable("total_update") }}>เวลาที่ทำงานทั้งหมด</TableCell>
                                        <TableCell onClick={() => { setSortBy("total_time"); changeSortable("total_time") }}>เวลาที่ทำเกิน</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody style={{ textAlign: 'center' }}>
                                    {data.filter(filterCondition).sort(sortData()).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((res, i) => (
                                        <TableRow key={i}>
                                            <TableCell>{res.type}</TableCell>
                                            <TableCell>{res.total_work}</TableCell>
                                            <TableCell >{res.count_close}</TableCell>
                                            <TableCell >{res.count_declice}</TableCell>
                                            <TableCell>{res.total_new == 0 ? "-" : secondsToDhms(res.total_new)}</TableCell>
                                            <TableCell>{res.total_update == 0 ? "-" : secondsToDhms(res.total_update)}</TableCell>
                                            <TableCell>{res.total_time == 0 ? "-" : secondsToDhms(res.total_time)}</TableCell>
                                        </TableRow>
                                    ))
                                    }
                                </TableBody>


                            </Table>
                        </TableContainer>
                        {data.length > 10 && <TablePagination
                            rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: 'All', value: data.filter(filterCondition).length },
                            ].filter((res) => res != data.filter(filterCondition).length)}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            component="div"
                            count={data.filter(filterCondition).length}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />}
                    </div>
                </Typography>
            </Container>
                : <div style={{ paddingLeft: '50px', paddingRight: '50px' }}>
                    <Typography component="div" style={{ backgroundColor: '#ffffffe6', borderRadius: '15px', height: '93vh' }}>
                        <Container style={{ marginTop: '10px', height: '5%', }}>
                            <span style={{ fontSize: "1.5em", fontWeight: 'bold', cursor: 'pointer' }} >
                                Report
                            </span>
                        </Container>
                        <Container style={{ padding: '25px', borderBottom: '2px solid lightgray' }}>

                            <Box style={{ margin: 'auto 0' }} color="primary.main">
                                <Search_Panel data={data} {...searchProps} />
                            </Box>
                        </Container>
                        <div style={{ padding: '10px' }}>
                            <div className="flex-container ">
                                <div style={{ marginRight: 'auto' }}>

                                    <TextField
                                        style={{ marginRight: 'auto', justifyContent: 'flex-end' }}
                                        variant="standard"
                                        value={searchText}
                                        onChange={(event) => requestSearch(event.target.value)}
                                        placeholder="Search…"
                                        InputProps={{
                                            startAdornment: <Search fontSize="small" />,
                                            endAdornment: (
                                                <IconButton
                                                    title="Clear"
                                                    aria-label="Clear"
                                                    size="small"
                                                    style={{ visibility: searchText != '' ? 'visible' : 'hidden' }}
                                                    onClick={() => requestSearch('')}
                                                >
                                                    <Clear fontSize="small" />
                                                </IconButton>
                                            ),
                                        }}
                                    />
                                </div>
                                <div style={{ marginLeft: 'auto' }}>
                                    <Button
                                        variant='contained'
                                        style={{ backgroundColor: "#6ab23a", color: 'whitesmoke', whiteSpace: 'nowrap', textTransform: 'none' }}
                                        size="small"
                                        onClick={Export_Excel}
                                    >
                                        Export<FontAwesomeIcon style={{ marginLeft: '5px' }} icon={faFileExcel} size="lg" />
                                    </Button>
                                </div>
                            </div>

                            <TableContainer component={Paper} style={{ borderRadius: '10px', marginTop: '2%', display: data.length == 0 ? 'none' : 'block' }}>
                                <Table className="ayLmao">
                                    <TableHead className="heheXd"
                                        style={{
                                            height: '50px',
                                            position: "sticky",
                                            textAlign: 'center'
                                        }}>
                                        <TableRow >
                                            <TableCell onClick={() => { setSortBy("type"); changeSortable("type") }}>Type Name</TableCell>
                                            <TableCell onClick={() => { setSortBy("total_work"); changeSortable("total_work") }}>จำนวนงานทั้งหมด</TableCell>
                                            <TableCell onClick={() => { setSortBy("count_declice"); changeSortable("count_declice") }}>จำนวนงานที่ปิดแล้วทั้งหมด</TableCell>
                                            <TableCell onClick={() => { setSortBy("count_declice"); changeSortable("count_declice") }}>จำนวนงานที่ปฏิเสธทั้งหมด</TableCell>
                                            <TableCell onClick={() => { setSortBy("total_new"); changeSortable("total_new") }}>ระยะเวลาในการรับเรื่องทั้งหมด</TableCell>
                                            <TableCell onClick={() => { setSortBy("total_update"); changeSortable("total_update") }}>เวลาที่ทำงานทั้งหมด</TableCell>
                                            <TableCell onClick={() => { setSortBy("total_time"); changeSortable("total_time") }}>เวลาที่ทำเกิน</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody style={{ textAlign: 'center' }}>
                                        {data.filter(filterCondition).sort(sortData()).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((res, i) => (
                                            <TableRow key={i}>
                                                <TableCell>{res.type}</TableCell>
                                                <TableCell>{res.total_work}</TableCell>
                                                <TableCell >{res.count_close}</TableCell>
                                                <TableCell >{res.count_declice}</TableCell>
                                                <TableCell>{res.total_new == 0 ? "-" : secondsToDhms(res.total_new)}</TableCell>
                                                <TableCell>{res.total_update == 0 ? "-" : secondsToDhms(res.total_update)}</TableCell>
                                                <TableCell>{res.total_time == 0 ? "-" : secondsToDhms(res.total_time)}</TableCell>
                                            </TableRow>
                                        ))
                                        }
                                    </TableBody>


                                </Table>
                            </TableContainer>
                            {data.length > 10 && <TablePagination
                                rowsPerPageOptions={[
                                    5,
                                    10,
                                    25,
                                    { label: 'All', value: data.filter(filterCondition).length },
                                ].filter((res) => res != data.filter(filterCondition).length)}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                component="div"
                                count={data.filter(filterCondition).length}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />}
                        </div>
                    </Typography>
                </div>
            }
        </React.Fragment>
    )

}

export default Report